@if (basket?.Charges) {
  <div class="basket-charges" id="basket-charges">
    @if (!showErrorsOnly) {
      <div class="basket-charge-total">
        @for (charge of charges; track $index) {
          <div class="basket-charge-list-item">
            <span>{{ charge.narrative }}</span>
            <samp>{{ charge.price | currency : 'GBP'  }}</samp>
          </div>
        }

        @if (loyaltyDiscount > 0) {
          <div class="basket-charge-list-item">
            <span>Loyalty Discount</span>
            <div class="basket-charge-list-item-group">
              <samp>-{{ loyaltyDiscount | currency:'GBP' }}</samp>
              @if (!orderComplete) {
                <mat-icon class="delete-icon" (click)="removeLoyalty()">delete_forever</mat-icon>
              }
            </div>
          </div>
        }

        @if (basket.VoucherCode && (!basket.UnlockedProductIds || basket.UnlockedProductIds?.length === 0)) {
          <div class="basket-charge-list-item">
            <span>{{ voucherNarrative }}</span>
            <div class="basket-charge-list-item-group">
              <samp>{{ voucherPrice | currency : 'GBP' }}</samp>
              @if (!orderComplete) {
                <mat-icon class="delete-icon" (click)="removeVoucher()">delete_forever</mat-icon>
              }
            </div>
          </div>
        }

        @if (basketTotal > 0) {
          <div class="basket-charge-list-item basket-total">
            <span>Total</span>
            <samp>{{ basketTotal || 0 | currency : 'GBP' }}</samp>
          </div>
        }
      </div>
    }

    @if (basketIssues?.length > 0) {
      <div class="basket-charge-errors">
        @for (issue of basketIssues; track $index) {
          <span>{{ issue }}</span>
        }
      </div>
    }
  </div>
}
